import { render } from "./Exchange.vue?vue&type=template&id=6c9c1c94&scoped=true&ts=true"
import script from "./Exchange.vue?vue&type=script&lang=ts"
export * from "./Exchange.vue?vue&type=script&lang=ts"

import "./Exchange.vue?vue&type=style&index=0&id=6c9c1c94&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9c1c94"]])

export default __exports__